import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { paymentClientSlice } from '../data/paymentClientSlice';
import { cookieDetailsSlice } from '../data/cookieDetailsSlice';
import { browserDetailsSlice } from '../data/browserDetailsSlice';
import { userDetailsSlice } from '../data/userDetailsSlice';
import { persistStore, persistReducer } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';
import {paymentTabsSlice} from "../data/paymentTabsSlice";

const paymentClientSliceConfig = {
  key: "paymentClientSlice",
  storage: sessionStorage
};

const cookieDetailsSliceConfig = {
  key: "cookieDetailsSlice",
  storage: sessionStorage
};

const browserDetailsSliceConfig = {
  key: "browserDetailsSlice",
  storage: sessionStorage
};

const userDetailsSliceConfig = {
  key: "userDetailsSlice",
  storage: sessionStorage
};

const rootPersistConfig = {
  key: "root",
  storage: sessionStorage
};

const paymentTabsSliceConfig = {
  key: "paymentTabsSlice",
  storage: sessionStorage
};

const rootReducer = combineReducers({
  paymentClient: persistReducer(paymentClientSliceConfig, paymentClientSlice.reducer),
  cookieDetails: persistReducer(cookieDetailsSliceConfig, cookieDetailsSlice.reducer),
  browserDetails: persistReducer(browserDetailsSliceConfig, browserDetailsSlice.reducer),
  userDetailsResponse: persistReducer(userDetailsSliceConfig, userDetailsSlice.reducer),
  paymentTabs: persistReducer(paymentTabsSliceConfig, paymentTabsSlice.reducer)
});

export const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer)
});

export const persistor = persistStore(store);
